export * from './LogoMicrosoftIcon';
export * from './LogoMicrosoftIcon16Light';
export * from './LogoMicrosoftIcon16Regular';
export * from './LogoMicrosoftIcon16Solid';
export * from './LogoMicrosoftIcon20Light';
export * from './LogoMicrosoftIcon20Regular';
export * from './LogoMicrosoftIcon20Solid';
export * from './LogoMicrosoftIcon24Regular';
export * from './LogoMicrosoftIcon24Solid';
export * from './LogoMicrosoftIcon32Regular';
export * from './LogoMicrosoftIcon64Regular';
